import { FormattedMessage } from 'react-intl';

import { useUserContext } from '@/context/UserContext.tsx';

export const ExecutedTileField = ({
  label,
  value,
  isLast = false,
}: {
  label: string | undefined;
  value: string | number | null | undefined;
  isLast?: boolean;
}) => {
  const user = useUserContext();
  const isInternalSales = user?.currentUser.userType === 'Internal Sales';

  return (
    <div className={`row mx-3 fw-bold py-1 d-flex flex-between ${!isLast ? 'border-bottom' : ''}`} key={label}>
      <div className="text-secondary">
        {/* @ts-ignore */}
        <FormattedMessage id={`order.form.${label}`} values={{ isInternalSales }} />
      </div>
      <div data-e2e={label} className="text-primary">
        {value}
      </div>
    </div>
  );
};
